// Data/footer.js - Just update this file in your project

export const CustomerCareOptions = [
    {
        option: "Help Center",
        path: "/customercare#help"
    },
    {
        option: "How to Buy",
        path: "/customercare#buy"
    },
    {
        option: "Corporate & Bulk",
        path: "/customercare#bulk"
    },
    {
        option: "Returns & Refunds",
        path: "/customercare#returns"
    },
    {
        option: "Contact Us",
        path: "/customercare#contact"
    },
    {
        option: "Purchase Protection",
        path: "/customercare#protection"
    }
];